"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./RequiredText.scss");
var RequiredText = function RequiredText(_ref) {
  var requiredField = _ref.requiredField,
    elementLocator = _ref.elementLocator;
  return _react.default.createElement("p", {
    className: "required-field-text",
    "data-locator": "" + elementLocator
  }, "*" + requiredField);
};
RequiredText.defaultProps = {
  requiredField: '',
  elementLocator: ''
};
var _default = RequiredText;
exports.default = _default;
module.exports = exports["default"];